import { mapState, mapMutations, mapGetters } from "vuex";
import config from "../../config/index";

const minin = {
  data() {
    return {
      tabIdx: 0,
      tabData: [],
      formInline: {},
      formCtrl: [],
      page: 1,
      limit: config.PAGE_SIZES[0] || 10,
      total: 0,
      tableData: [],
      getTotalProperty: [],
      loading: false,
      getListUrl: 'rec',
      baseParams: [],
      delUrl: 'delre',
      getOptionUrl: 'index',
      btns: [],
      selection: [],
      mform: {},
      mformCtrl: [],
      modalSubmitUrl: 'addedu',
      searchKeyOptions: [],
      allBtnWidth: '100px',
      tempCols: [],
      rform: {},
      defaultTh: [],
      userviewhistory: {},
      // 储存初始值，用于重置
      MONTH: null,
      viewMode: false,
    };
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
    ...mapGetters([
      'tabIdxMemo',
    ]),
    DATE_OBJ() {
      const date = new Date()
      const y = date.getFullYear() + ''
      let m = date.getMonth() + 1
      let d = date.getDate()
      let s = date.getTime()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return {
        y, m, d, s
      }
    },
    DATE() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return `${y}-${m}-${d}`
    },
    CURR_MONTH() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
    LAST_MONTH() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth()
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
  },
  methods: {
    ...mapMutations(['setTabIdx', 'setState']),
    setListHistory() {
      const arr = this.userviewhistory[location.href] || []
      this.tableData.map(v => {
        if (arr.includes(v.id)) {
          v.viewed = true
        }
      })
    },
    getUserViewHistory() {
      const str = localStorage.getItem('userviewhistory')
      // console.log(str)
      this.userviewhistory = JSON.parse(str) || {}
    },
    setUserViewHistory(id) {
      const arr = this.userviewhistory[location.href] || []
      if (!arr.includes(id)) {
        arr.push(id)
      }
      this.userviewhistory[location.href] = arr
      console.log(this.userviewhistory[location.href])
      localStorage.setItem('userviewhistory', JSON.stringify(this.userviewhistory))
    },
    // 表头设置相应事件
    onTableSelect({ value }) {
      // console.log(value)
      if (value && value.length) {
        const arr = []
        this.tempCols.map(v => {
          if (value.includes(v.label)) {
            arr.push(v)
          }
        })
        // console.log([...arr])
        this.cols = arr
        this.doLayout()
      }
    },
    // 导出
    Export(name = 'test') {
      this.$confirm("确定要导出文件到Excel?", "导出提示", {
        //这里是加一个导出提示，根据个人喜好，可加可不加   
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        setTimeout(() => {
          var xlsxParam = { raw: true }  // 导出的内容只做解析，不进行格式转换
          const eTable = document.querySelector('.table-wrap .el-table')
          let fix = document.querySelector('.el-table__fixed-right');
          let wb;
          if (fix) { //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
            wb = this.$XLSX.utils.table_to_book(eTable.removeChild(fix), xlsxParam);
            eTable.appendChild(fix);
          } else {
            wb = this.$XLSX.utils.table_to_book(eTable);
          }
          // let tables = document.getElementById('eTable');   //这里是绑定元素，输入你要导出的table表格的id
          // let table_book = this.$XLSX.utils.table_to_book(tables, xlsxParam);
          const table_write = this.$XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
          });
          try {
            this.$FileSaver.saveAs(
              new Blob([table_write], { type: "application/octet-stream" }), `${name}.xlsx`   //这里是文件名
            );
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, table_write);
          }
          return table_write;
        }, 500)
      })
    },
    onSearchItemChange({ key }) {
      if (['starttime', 'edittime', 'fleet', 'month'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    onSizeChange(n) {
      // console.log(n);
      this.limit = n;
      this.getList();
    },
    onCurrentChange(n) {
      // console.log('current change to', n);
      this.page = n;
      this.getList();
    },
    onSelectionChange(arr) {
      this.selection = [...arr]
    },
    onToggleTab({ index }) {
      this.tabIdx = index;
      this.getList();
    },
    onSearch(form) {
      // 搜索前页码重置，避免搜不到
      this.page = 1
      this.formInline = { ...form };
      // console.log({ ...this.formInline });
      this.getList();
    },
    onComSearchChange({ key, value }) {
      // console.log(key, value)
      // console.log({ ...this.formInline })
      // 如果键有值则存,无则不存
      if (key) this.formInline[key] = value
      // console.log({ ...this.formInline })
    },
    onReset() {
      console.log("onReset");
      // console.log(this.$refs)
      // 复合搜索框重置
      const comFormCtrl = this.$refs['comFormCtrl']
      comFormCtrl && comFormCtrl.reset()
      // 复合日期选择重置
      const comFormDate = this.$refs['comFormDate']
      comFormDate && comFormDate.reset()
      const obj = {}
      this.formCtrl.map(v => {
        // if (v.keyName == 'fleet') {
        //   // 重置为全部
        //   obj[v.keyName] = ''
        // } else {
          obj[v.keyName] = undefined
        // }
      })
      this.searchKeyOptions.map(v => {
        obj[v.value] = undefined
      })
      // 请求必填参数
      this.baseParams.map(v => {
        if (v == 'year') {
          // 重置为默认年份
          obj[v] = this.DATE_OBJ.y
        } else if ([
          'month',
          'predict_loading_date',
          'predict_unloading_date',
          'addtime'
        ].includes(v) && this.MONTH) {
          // 重置为默认月份
          obj[v] = this.MONTH
        } else {
          obj[v] = this.formInline[v]
        }
      })
      console.log(obj)
      this.formInline = obj;
      // 清除储存的搜索条件
      const path = this.$route.path
      this.setState({
        key: 'formInline' + path,
        value: {},
      })
      // 回到首页
      this.page = 1;
      this.getList();
    },
    delete(id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(id)
        this.delReq(id);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    delReq(id) {
      this.loading = true
      let url = `${this.baseUrl}/${this.delUrl}`;
      const params = {
        userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
    getList(staticfresh) {
      this.loading = true
      if (!staticfresh) {
        this.tableData = [];
      }
      let url = `${this.baseUrl}/${this.getListUrl}`;
      const params = {
        userid: this.user.id,
        page: this.page,
        limit: this.limit,
      }
      const object = this.formInline
      // console.log('formInline', { ...this.formInline })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, (res) => {
        this.loading = false
        const pricingMap = {
          1: '按重量计费',
          2: '按体积计费',
          3: '按件数计费',
          4: '按里程计费',
          5: '按趟计费'
        };
        res.data.map(v => {
          const { pricing } = v
          if (pricing) {
            // 将数字替换为对应的汉字
            v.pricing_name = pricingMap[pricing] || pricing; // 如果找不到对应值，设为空字符串
            if (pricing == 5 || pricing == '按趟计费') {
              v.inton = '-'
              v.unton = '-'
            }
          }
        })

        // console.log(res.data)
        this.tableDataHandler(res);
        if (this.$refs.table) {
          // console.log(this.$refs.table.$el)
          this.$refs.table.setScrollTop()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    handleClick() {
      // console.log(this.activeName)
      this.formInline.month = this.activeName;
      this.getList();
    },
    dataObjHandler(v) {
      const o = {}
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          const ele = v[key]
          if (key.includes('time') && (typeof ele === 'string') && ele.includes(' ')) {
            const arr = ele.split(' ')
            o[key] = arr[0];
          } else {
            o[key] = v[key];
          }
        }
      }
      return o
    },
    tableDataHandler(res) {
      if (typeof res === 'string') {
        this.$message({
          type: 'error',
          message: res
        });
      } else {
        const { count, data } = res
        this.total = count
        if (data && data.length) {
          // console.log(data)
          // this.tableData = [...data]
          this.tableData = data.map(v => {
            return this.dataObjHandler(v)
          })
          this.setListHistory()
        }
      }
    },
    getTotal(param) {
      const { columns, data } = param;
      // console.log(param)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 && column.type !== 'selection') {
          // console.log({...column}, {...data})
          sums[index] = '合计';
          return;
        }
        if (columns[0].type === 'selection' && index === 1) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) && this.getTotalProperty.includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            // console.log(value, prev, curr)
            if (!isNaN(value)) {
              return this.keep2(Number(prev) + Number(curr));
            } else {
              return this.keep2(prev);
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    keep2(n) {
      return (Number(n)).toFixed(2)
    },
    showDialog(str = 'dialog') {
      this.$refs[str] && this.$refs[str].show()
    },
    hideDialog(str = 'dialog') {
      typeof str == 'string' ? null : str = 'dialog'
      this.$refs[str] && this.$refs[str].hide()
    },
    getYearMonth() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
    getDate() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return `${y}-${m}-${d}`
    },
    getDateObj() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      let s = date.getTime()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return {
        y, m, d, s
      }
    },
    getFleet() {
      this.post(`base/getmyfleet`, {}, this.setFleet, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setFleet({ team }) {
      // console.log(team)
      this.formCtrl.map(v => {
        if (v.keyName == 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
      this.$forceUpdate()
    },
    setCtrlOption(v, team, key1, key2) {
      this.$set(v, 'options', [
        { label: '全部', value: '' },
      ])
      team.map(c => {
        v.options.push({
          label: c[key1 || 'name'],
          value: c[key2 || 'id'],
        })
      })
    },
    setQueryParams() {
      const object = this.$route.query
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          this.formInline[key] = object[key];
        }
      }
    },
    getOptions(params = {}) {
      this.post(`${this.baseUrl}/${this.getOptionUrl}`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions(res) {
      console.log(res)
    },
    onModalChange({ key, value }) {
      // console.log(key, value)
      // console.log(key === 'money')
      if (key.includes('photo')) {
        this.mform[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else {
        // this.mform[key] = value;
        this.$set(this.mform, key, value)
      }
      // console.log({ ...this.mform })
    },
    onModalSubmit() {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true
      let url = `${this.baseUrl}/${this.modalSubmitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.paramsPackage(params, this.mform)
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    paramsPackage(params, object) {
      console.log({ ...params })
      console.log({ ...object })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
    },
    reSetListStatus() {
      // console.log('store', { ...this.store })
      if (!this.store) return
      const path = this.$route.path
      if (this.store['page' + path]) {
        this.page = this.store['page' + path]
      }
      if (this.store['limit' + path]) {
        this.limit = this.store['limit' + path]
      }
      if (this.store['formInline' + path]) {
        this.formInline = {
          ...this.formInline,
          ...this.store['formInline' + path]
        }
        // console.log('formInline', { ...this.formInline })
      }
    },
    doLayout() {
      // console.log(this.$refs.table)
      if (this.$refs.table && this.$refs.table.doLayout) {
        this.$refs.table.doLayout()
      }
    },
    getMonthRange(month) {
      let a = []
      if (month) {
        const m = Number(month.split('-')[1])
        const y = Number(month.split('-')[0])
        // console.log(m)
        let d = 30
        if ([1, 3, 5, 7, 8, 10, 12].includes(m)) {
          d = 31
        } else if (m == 2) {
          d = 28
        } else if (m == 2 && ((y % 400 === 0) || (y % 4 === 0 && y % 100 !== 0))) {
          d = 29
        }
        a.push(`${month}-01`, `${month}-${d}`)
      }
      return a
    },
  },
  updated() {
    this.doLayout();
  },
  created() {
    // 先给所有检索字段赋默认值，以便于触发控件渲染
    this.formCtrl.map(v => {
      // 直接赋值有时候会引起渲染失效，不保险
      // this.formInline[v.keyName] = ''
      const val = this.formInline[v.keyName]
      this.$set(this.formInline, v.keyName, val || undefined)
    })
    // console.log('formInline', { ...this.formInline })
  },
  mounted() {
    // 如果搜索条件为空,则赋予搜索条件初始值,以便于触发控件渲染
    // if (!Object.keys(this.formInline).length) {
    //   this.formCtrl.map(v => {
    //     this.formInline[v.keyName] = ''
    //   })
    // }
    // 恢复列表页状态
    this.reSetListStatus()
    // console.log([...this.baseParams])
    // 没有前置参数，且路由中没有参数，可以直接请求
    if (!this.baseParams.length && !Object.keys(this.$route.query).length) {
      // 恢复状态后再搜索
      this.$nextTick(this.getList)
    }
    // this.tabIdx = this.tabIdxMemo(this.$route.path) || 0
    // 获取浏览记录
    this.getUserViewHistory()
  },
  beforeRouteLeave(to, from, next) {
    // 监听到页面离开时调用
    // to: 即将要进入的目标的路由对象
    // from: 当前导航正要离开的路由
    // next: 是一个function，一定要调用该方法，否则路由不会跳转。
    // console.log(from)
    // console.log(to)
    const path = this.$route.path
    if ((to.path.includes('view')
      || to.path.includes('fee')
      || to.fullPath.includes('?'))
      /**详情列表不存**/
      && !to.path.includes('table')
    ) {
      // console.log(this.page)
      // 储存页码
      this.setState({
        key: 'page' + path,
        value: this.page,
      })
      // console.log(this.store['page' + path])
      // 储存搜索条件
      // console.log({ ...this.formInline })
      this.setState({
        key: 'formInline' + path,
        value: this.formInline,
      })
      // console.log(this.store['formInline' + path])
      if (this.$refs.table) {
        this.setState({
          key: 'scrollTop' + path,
          value: this.$refs.table.scrollTop || 0,
        })
      }
      // console.log('store 1', { ...this.store })
    } else {
      this.setState({
        key: 'page' + path,
        value: 1,
      })
      this.setState({
        key: 'formInline' + path,
        value: {},
      })
      this.setState({
        key: 'scrollTop' + path,
        value: 0,
      })
      // console.log('store 2', { ...this.store })
    }
    // 一定要调用next
    next()
  },
  // watch: {
  //   page: {
  //     deep: true,
  //     handler(newVal, oldVal) {
  //       console.log(newVal, oldVal)
  //     },
  //   }
  // },
}

export default minin